



























import { defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { SamplingCollection } from '@/store/types';

export default defineComponent({
	name: 'CreateSamplingCollectionButton',
	components: { ConfirmDialog },
	props: {
		fieldId: {
			type: String,
			required: true,
		},
		locationCollectionId: {
			type: String,
		},
		draftSamplingCollections: {
			type: Array as () => SamplingCollection[],
		},
	},
	setup({ fieldId, locationCollectionId, draftSamplingCollections }, { root }) {
		const showChooseSamplingCollectionDialog = ref(false);
		return {
			handleClick(forceCreate: boolean) {
				if (forceCreate || !draftSamplingCollections || draftSamplingCollections.length === 0) {
					root.$router.push({
						path: '/create-sampling-collection',
						query: {
							field: fieldId,
							object: locationCollectionId,
						},
					});
				} else {
					showChooseSamplingCollectionDialog.value = true;
				}
			},
			disabled: !locationCollectionId,
			showChooseSamplingCollectionDialog,
		};
	},
});
